import React from 'react';
const stats = [{
  value: '+1.800',
  label: 'estudiantes confían'
}, {
  value: '3',
  label: 'niveles disponibles'
}, {
  value: '4.9/5',
  label: 'calificación ⭐'
}, {
  value: '🇦🇷',
  label: 'Todo el país'
}];
const testimonials = [{
  initials: 'LG',
  quote: '"Llegué a tercer año con apuntes de 5 compañeros distintos que no coincidían entre sí. Con el Nivel 1 de Médico en Proceso tuve por primera vez un sistema claro para entender qué estudiar y en qué orden. Aprobé Anatomía con 8."',
  author: '— Lucas G., Córdoba | 3° año Medicina UNC'
}, {
  initials: 'SV',
  quote: '"Siempre llegaba a los parciales sin saber si había estudiado lo correcto. Con el Nivel 2 eso cambió: tengo el sistema de estudio armado, sé cómo organizarme y cómo repasar. Ya aprobé Farmacología y Fisiología con él."',
  author: '— Sofía V., Buenos Aires | 4° año Medicina UBA'
}, {
  initials: 'MP',
  quote: '"Me tomé el Nivel 3 con los editables y fue un cambio total. Tengo todo organizado por tomos, sé qué material usar para cada materia y llegué a los finales mucho más tranquila y preparada que nunca."',
  author: '— Martina P., Rosario | 3° año Medicina UNR'
}];
export function SocialProof() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900 text-base leading-6 relative" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(248,251,255) 0%, rgb(224,242,254) 15%, rgb(224,242,254) 85%, rgb(240,249,255) 100%)'
  }} data-id="element-347">
      <div className="mx-auto max-w-4xl" data-id="element-348">

        {/* STATS GRID */}
        <div className="mb-8 grid grid-cols-2 md:grid-cols-4 gap-3 text-center" data-id="element-349">
          {stats.map(stat => <div key={stat.label} data-id="element-350">
              <div className="text-2xl sm:text-4xl leading-[32px] sm:leading-[40px] font-black text-gray-900" data-id="element-351">
                {stat.value}
              </div>
              <div className="mt-1 text-[10px] sm:text-xs font-semibold" style={{
            color: '#0284c7'
          }} data-id="element-352">
                {stat.label}
              </div>
            </div>)}
        </div>

        {/* TESTIMONIALS GRID */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-353">
          {testimonials.map(t => <div key={t.initials} className="flex items-start gap-2 bg-white/80 rounded-lg p-3 shadow-sm" style={{
          border: '1px solid rgba(56,189,248,0.30)'
        }} data-id="element-354">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-black" style={{
            color: '#0284c7',
            background: 'linear-gradient(135deg, rgba(2,132,199,0.12) 0%, rgba(14,165,233,0.12) 100%)'
          }} data-id="element-355">
                {t.initials}
              </div>
              <div data-id="element-356">
                <div className="mb-1 text-[10px]" style={{
              color: '#0ea5e9'
            }} data-id="element-357">
                  ⭐⭐⭐⭐⭐
                </div>
                <p className="text-xs font-medium text-gray-900 m-0" data-id="element-358">
                  {t.quote}
                </p>
                <p className="text-[10px] text-gray-500 mt-1 mb-0" data-id="element-359">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>

      {/* Degradé de integración con PainPoints */}
      <div className="absolute bottom-0 left-0 right-0 h-16 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent 0%, rgb(248,250,255) 100%)'
    }} data-id="element-360" />
    </section>;
}